export const uniqueId32 = () => {
    const raw = crypto.randomUUID().replace(/-/g, '').slice(0, 30); return `${raw.slice(0, 8)}-${raw.slice(8, 15)}-${raw.slice(15, 23)}-${raw.slice(23, 30)}`;
};
